<template>
<div>
	<div class="d-none d-lg-block py-1" id="navbar-navigation-content">
		<div class="container-menu">
			<b-navbar toggleable="lg" class="nav-navigation">
				<b-navbar-nav class="d-flex justify-content-between w-100"  >
					<li :style="$route.fullPath == '/eres-empleador#pg1' ? 'background: #df9234; color:#fff; margin-left: 100px; width:7%;' : 'margin-left: 100px'">
						<a href="/eres-empleador#pg1" class="nav-link p-0 m-0" @click="url = 'pg1'" >
							<span :style="$route.fullPath == '/eres-empleador#pg1'  ? 'color:#fff; font-size:13px;': 'font-size:13px;'">ÚNETE</span>
						</a>
					</li>
					<li  :style="$route.fullPath == '/eres-empleador#pg2' ? 'background: #df9234; color:#fff; margin-left: 100px; width:11%;' : 'margin-left: 100px'">
						<a href="/eres-empleador#pg2" class="nav-link p-0 m-0"  @click="url = 'pg2'">
							<span :style="$route.fullPath == '/eres-empleador#pg2'  ? 'color:#fff; font-size:13px;': 'font-size:13px;'">PUBLICA EMPLEOS</span>
						</a>
					</li>
					<li  :style="$route.fullPath == '/eres-empleador#pg3'  ? 'background: #df9234; color:#fff; margin-left: 100px; width:11%;' : 'margin-left: 100px'">
						<a href="/eres-empleador#pg3" class="nav-link p-0 m-0"  @click="url = 'pg3'">
							<span :style="$route.fullPath == '/eres-empleador#pg3'  ? 'color:#fff; font-size:13px;': 'font-size:13px;'">BUSCA CANDIDATOS</span>
						</a>
					</li>
					<li  :style="$route.fullPath == '/eres-empleador#pg4'  ? 'background: #df9234; color:#fff; margin-left: 100px; width:11%;' : 'margin-left: 100px'">
						<a href="/eres-empleador#pg4" class="nav-link p-0 m-0"  @click="url = 'pg4'">
							<span :style="$route.fullPath == '/eres-empleador#pg4'  ? 'color:#fff; font-size:13px;': 'font-size:13px;'">RANKING EMPRESAS</span>
						</a>
					</li>
					<li :style="$route.fullPath == '/eres-empleador#pg5'  ? 'background: #df9234; color:#fff; margin-left: 100px; width:14%;' : 'margin-left: 100px'">
						<a href="/eres-empleador#pg5" class="nav-link p-0 m-0"  @click="url = 'pg5'">
							<span :style="$route.fullPath == '/eres-empleador#pg5'  ? 'color:#fff; font-size:13px;': 'font-size:13px;'">CONTRATA TU MEMBRESIA</span>
						</a>
					</li>
					<li :style="$route.fullPath == '/eres-empleador#pg6'  ? 'background: #df9234; color:#fff; margin-left: 100px; width:7%;' : 'margin-left: 100px'">
						<a href="/eres-empleador#pg6" class="nav-link p-0 m-0"  @click="url = 'pg6'">
							<span :style="$route.fullPath == '/eres-empleador#pg6'  ? 'color:#fff; font-size:13px;': 'font-size:13px;'">BLOG</span>
						</a>
					</li>
				</b-navbar-nav>
			</b-navbar>
		</div>
	</div>
	
</div>
</template>

<script>
export default {
	name: "menu_empleador",
	data() {
		return {
			url:"pg1"
		}
	},
	created() {
		this.bus.$on("cambiar_empleador", data => {
			this.url = data;
		});
	}
}
</script>

<style scoped>
#navbar-navigation-content{
	background-color: white;
	width: 100%;
	border-bottom: 1px solid lightgray;
}
.router-link-exact-active{
	box-shadow: none !important;
	border: none !important;
}
a.nav-link.router-link-exact-active.router-link-active{
	color: #ed8f00 !important;
}
.container-menu{
	margin: 0 5.5vw;
	/*margin: 0 5.5vw 0 10.6vw;*/
}
</style>



// WEBPACK FOOTER //
// src/components/landing/menu_empleador.vue